module.exports = __webpack_public_path__ + "static/media/nft-ipo-icon1.3177c7e7.svg";